// extracted by mini-css-extract-plugin
module.exports = {"CountrySelector":"CountrySelector__CountrySelector___3KYwk","CountrySpan":"CountrySelector__CountrySpan___2cLHB"};